import MemberAccountReportTypes from './member-account-report.types';

/** ***************** GET MEMBER ACCOUNT REPORT DETAILS FOR SAVINGS START *********************** */
export const getMemberAccountReportDetailsForSavingsStart = (getData: any) => ({
	type: MemberAccountReportTypes.GET_MEMBER_ACCOUNT_REPORT_SAVINGS_START,
	payload: getData,
});

export const getMemberAccountReportDetailsForSavingsSuccess = (successData: any) => ({
	type: MemberAccountReportTypes.GET_MEMBER_ACCOUNT_REPORT_SAVINGS_SUCCESS,
	payload: successData,
});

export const getMemberAccountReportDetailsForSavingsFailure = (failureData: any) => ({
	type: MemberAccountReportTypes.GET_MEMBER_ACCOUNT_REPORT_SAVINGS_FAILURE,
	payload: failureData,
});

export const getMemberAccountReportDetailsForSavingsResponseResetStart = () => ({
	type: MemberAccountReportTypes.GET_MEMBER_ACCOUNT_REPORT_SAVINGS_RESPONSE_RESET,
});

export const getMemberAccountReportDetailsForSavingsResponseChanged = () => ({
	type: MemberAccountReportTypes.GET_MEMBER_ACCOUNT_REPORT_SAVINGS_RESPONSE_CHANGED,
});
/** ***************** GET MEMBER ACCOUNT REPORT DETAILS FOR SAVINGS END *********************** */

/** ***************** GET MEMBER ACCOUNT REPORT DETAILS FOR FIXED DEPOSIT START *********************** */
export const getMemberAccountReportDetailsForFixedDepositStart = (getData: any) => ({
	type: MemberAccountReportTypes.GET_MEMBER_ACCOUNT_REPORT_FIXED_DEPOSIT_START,
	payload: getData,
});

export const getMemberAccountReportDetailsForFixedDepositSuccess = (successData: any) => ({
	type: MemberAccountReportTypes.GET_MEMBER_ACCOUNT_REPORT_FIXED_DEPOSIT_SUCCESS,
	payload: successData,
});

export const getMemberAccountReportDetailsForFixedDepositFailure = (failureData: any) => ({
	type: MemberAccountReportTypes.GET_MEMBER_ACCOUNT_REPORT_FIXED_DEPOSIT_FAILURE,
	payload: failureData,
});

export const getMemberAccountReportDetailsForFixedDepositResponseResetStart = () => ({
	type: MemberAccountReportTypes.GET_MEMBER_ACCOUNT_REPORT_FIXED_DEPOSIT_RESPONSE_RESET,
});

export const getMemberAccountReportDetailsForFixedDepositResponseChanged = () => ({
	type: MemberAccountReportTypes.GET_MEMBER_ACCOUNT_REPORT_FIXED_DEPOSIT_RESPONSE_CHANGED,
});
/** ***************** GET MEMBER ACCOUNT REPORT DETAILS FOR FIXED DEPOSIT END *********************** */
